import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { Cdate, dayInfo } from 'src/app/models/cdate';
import { DayOfList } from 'src/app/models/list-day';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { ListDayService } from 'src/app/services/list-day.service';
import { UserService } from 'src/app/services/user.service';
import { AlreadySessionComponent } from '../../../shared/modals/already-session/already-session.component';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { SessionsService } from 'src/app/services/sessions.service';
import { ListSessionBisComponent } from '../list-session-bis/list-session-bis.component';
import { User } from 'src/app/micro-services/user/models/user';

@Component({
  selector: 'app-list-day',
  templateUrl: './list-day.component.html',
  styleUrls: ['./list-day.component.scss'],
})
export class ListDayComponent implements OnInit {

  coach: User;
  pageNumber: number = 1;
  @ViewChild('infiniteScroll', { static: false }) infiniteScroll: IonInfiniteScroll;

  constructor(
    public apiProvider: ApiProviderService,
    public userService: UserService,
    private datePipe: DatePipe,
    public listDayService: ListDayService,
    public modalCtrl: ModalController,
    private sessionService: SessionsService
  ) { }

  ngOnInit() {

    this.coach = this.userService.getUser();
    this.getDates(1);
  }

  onIonInfinite(ev) {
    this.getDates(this.pageNumber);
    ev.target.complete();
  }

  getDates(page: number) {

    this.apiProvider.getListOfDayPerSession(this.coach, this.datePipe.transform(new Date(), 'yyyy-MM-dd H:mm:ss'), this.pageNumber, 60)
      .subscribe((daysInfos: dayInfo[]) => {

        daysInfos.forEach((dayInfo: any) => {
          if (typeof dayInfo.date === "string") {
            const [year, month, day] = dayInfo.date.split("-").map(Number);
            dayInfo.date = { year, month, day }; // Transformer en objet
          }

          dayInfo.date.cDate = new Date(
            dayInfo.date.year,
            dayInfo.date.month - 1,
            dayInfo.date.day,
            0, 0, 0
          );
        });
        for (let i = 0; i < 60; i++) {

          // Check if we are changing month. If yes add new element title to the list
          let tmpLastLoadingDate = new Date(JSON.parse(JSON.stringify(this.listDayService.lastLoadingDate)));
          tmpLastLoadingDate.setDate(tmpLastLoadingDate.getDate() - 1);

          if (tmpLastLoadingDate.getMonth() != this.listDayService.lastLoadingDate.getMonth()) {
            let monthTitle = new DayOfList();
            monthTitle.date = new Date(JSON.parse(JSON.stringify(this.listDayService.lastLoadingDate)));
            monthTitle.isNewMonth = true;
            monthTitle.sessionCount = 0;
            this.listDayService.dates.push(monthTitle);
          }
          //

          let dateFound = false;
          let dayOfList = new DayOfList();
          dayOfList.date = new Date(JSON.parse(JSON.stringify(this.listDayService.lastLoadingDate)));
          dayOfList.isNewMonth = false;



          daysInfos.forEach((dayInfo: dayInfo) => {
            if (dayInfo.date.cDate.toISOString() == this.listDayService.lastLoadingDate.toISOString()) {

              dateFound = true;
              dayOfList.sessionCount = dayInfo.count;
            }
          });

          if (!dateFound) {
            dayOfList.sessionCount = 0;
          }

          this.listDayService.dates.push(dayOfList);

          this.listDayService.lastLoadingDate.setDate(this.listDayService.lastLoadingDate.getDate() + 1);
          this.listDayService.lastLoadingDate.setHours(0, 0, 0, 0);


        }
        this.pageNumber++;
      })
  }
  async showSession(date: DayOfList) {
    this.sessionService.selectedDate = new Date(JSON.parse(JSON.stringify(date.date)));

    // Vérifier et fermer la modal existante avant d’en créer une nouvelle
    const topModal = await this.modalCtrl.getTop();
    if (topModal) {
      await this.modalCtrl.dismiss();
    }
    const modal = await this.modalCtrl.create({
      component: ListSessionBisComponent,
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "backdrop" && data) {
      let dateItem = this.listDayService.dates.find(d => d.date.toDateString() === data.date.toDateString());
      if (dateItem) {
        dateItem.sessionCount = data.countSession;
      }
    }
  }

}
